import { z } from "zod";

export const EnrollmentPeriodFormSchema = z.object({
  name: z.string().min(1, "Enrollment period name is required."),
  active: z.boolean(),
  key: z.string().nullable(),
  use_service_offerings: z.boolean(),
  use_service_offering_seat_types: z.boolean(),
});

export type EnrollmentPeriodFormType = z.infer<
  typeof EnrollmentPeriodFormSchema
>;
